import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  LIFECYCLE_GROUP_LABEL,
  LIFECYCLE_LABEL,
  LOT_STAGES_BY_GROUP,
  LOT_STAGE_GROUP_ORDER,
  type LotStage,
} from "@/features/animals/lifecycleStates";

type Props = {
  value: LotStage | "";
  onChange: (next: LotStage) => void;
  ariaLabel?: string;
  placeholder?: string;
  disabled?: boolean;
};

export function LotStageSelect({ value, onChange, ariaLabel, placeholder, disabled }: Props) {
  return (
    <Select value={value} onValueChange={(next) => onChange(next as LotStage)} disabled={disabled}>
      <SelectTrigger className="h-10 w-full text-app-ink-1" aria-label={ariaLabel}>
        <SelectValue placeholder={placeholder ?? "Selecciona etapa"} />
      </SelectTrigger>
      <SelectContent>
        {LOT_STAGE_GROUP_ORDER.map((group) => (
          <SelectGroup key={group}>
            <SelectLabel>{LIFECYCLE_GROUP_LABEL[group]}</SelectLabel>
            {LOT_STAGES_BY_GROUP[group].map((stage) => (
              <SelectItem key={stage} value={stage}>
                {LIFECYCLE_LABEL[stage]}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
